import getUrl from "discourse/lib/get-url";

export default function basePath() {
  return getUrl("");
}
